import { Text } from '@/components/text';
import { Button } from '@/components/ui/button';
import { Colors } from '@/constants/theme';
import { StyleSheet } from 'react-native';
import { Gesture, GestureDetector } from 'react-native-gesture-handler';
import { useAnimatedStyle, useSharedValue, withSpring } from 'react-native-reanimated';
import { AnimatedView, View } from './ui/tw-wrappers';

interface SimulationCardProps {
  title: string;
  description: string;
  buttonLabel: string;
  onPress: () => void;
}

export function SimulationCard({ title, description, buttonLabel, onPress }: SimulationCardProps) {
  const pressed = useSharedValue(0);

  const tap = Gesture.Hover()
    .onBegin(() => {
      pressed.value = 1;
    })
    .onFinalize(() => {
      pressed.value = 0;
    });

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ scale: withSpring(pressed.value ? 1.02 : 1) }],
  }));

  return (
    <GestureDetector gesture={tap}>
      <AnimatedView className='bg-white md:border-[#E3E3E3] border-blue-600' style={[styles.container, animatedStyle]}>
        <View style={styles.content}>
          <Text type='defaultBold' style={styles.title}>
            {title}
          </Text>
          <Text style={styles.description}>{description}</Text>
        </View>
        <View style={styles.buttonContainer}>
          <Button label={buttonLabel} onPress={onPress} />
        </View>
      </AnimatedView>
    </GestureDetector>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    borderRadius: 24,
    padding: 22,
    minHeight: 200,
    borderWidth: 1,
    // borderColor: '#E3E3E3',
    shadowColor: Colors.light.shadow,
    shadowOffset: { width: 4, height: 4 },
    shadowOpacity: 1,
    shadowRadius: 0,
    elevation: 2,
    gap: 14,
  },
  content: {
    gap: 16,
  },
  title: {
    fontSize: 18,
    color: Colors.light.primary,
  },
  description: {
    fontSize: 14,
    lineHeight: 24,
    color: '#666',
  },
  buttonContainer: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    marginTop: 16,
  },
});
